import {
  CarFront,
  CircleUser,
  Compass,
  Contact as ContactIcon,
  CopyCheck,
  LayoutTemplate,
  Logs,
  UserRoundX,
} from 'lucide-react';

export const crmTabs = [
  {
    id: 'accounts',
    label: 'Accounts',
    icon: CircleUser,
    path: '/crm/accounts',
  },
  {
    id: 'contacts',
    label: 'Contacts',
    icon: ContactIcon,
    path: '/crm/contacts',
  },
  { id: 'drivers', label: 'Drivers', icon: CarFront, path: '/crm/drivers' },
  { id: 'guides', label: 'Guides', icon: Compass, path: '/crm/guides' },
  // Itinerary branding templates (logo, colours, price visibility). Lives here
  // rather than under /system-configuration because consultants — who cannot
  // see the admin menu at all — own their agency's layouts. Reads are gated by
  // `itineraries:read`, writes by `company_settings:*`; the route rule in
  // route-permissions.ts keeps `operation` (crm:read, no company_settings) out.
  {
    id: 'layouts',
    label: 'Layouts',
    icon: LayoutTemplate,
    path: '/crm/layouts',
  },
  { id: 'logs', label: 'Logs', icon: Logs, path: '/crm/logs' },
  // Duplicate-account review queue (XT-724). Sits beside Restored customers
  // because it is the same kind of surface: a finite cleanup worklist that
  // shrinks as it is worked, not day-to-day navigation. Reads are `crm:read`;
  // merging is admin-only and the page says so rather than hiding the queue.
  {
    id: 'duplicates',
    label: 'Duplicates',
    icon: CopyCheck,
    path: '/crm/duplicates',
  },
  // Data-integrity cleanup worklist: itineraries whose customer is a contact or
  // company that was soft-deleted, then restored (and RESTORED-labelled) because
  // it still owned itineraries. Last tab — it is a temporary remediation
  // surface, not day-to-day CRM navigation, and it self-empties as the backlog
  // is worked through.
  {
    id: 'orphaned-customers',
    label: 'Restored customers',
    icon: UserRoundX,
    path: '/crm/orphaned-customers',
  },
];
